import 'slick-carousel';

class Slider {
	constructor($el) {
		this.$el = $el;
		this.$imageSlider = $el.find('[data-slider="image-slider"]');
		this.$imageSlides = $el.find('[data-slider="image-slide"]');
		this.$textSlider = $el.find('[data-slider="text-slider"]');
		this.$textSlide = $el.find('[data-slider="text-slide"]');
		this.$dots = $el.find('[data-slider="dots"]');
		this.init();
	}

	init = () => {
		this.imageSlick = this.$imageSlider.slick({
			infinite: true,
			draggable: true,
			asNavFor: '.text-slider',
			arrows: false,
			speed: 1000,
		});

		this.textSlick = this.$textSlider.slick({
			infinite: true,
			draggable: true,
			asNavFor: '.image-slider',
			arrows: false,
			// autoplay: true,
			// autoplaySpeed: 5000,
			speed: 1000,
			dots: true,
			appendDots: this.$dots,
			adaptiveHeight: false,
		});

		this.$imageSlider.on('click', () => {
			this.$imageSlider.slick('slickNext');
		});
	};
}

export default Slider;
